<template>
  <div class="thousand_layout">
    <div class="right_box" v-loading="loading">
      <div class="right_box_title">
        <h2>{{$t('base.blocked')}}</h2>
      </div>
      <ul class="bolckList">
        <li v-for="(item , index) in list" :key="index">
          <div class="bolckName">
            <el-image class="like_img" :src="item.BlackListMember.HeadPortrait+'?imageView2/2/w/200'" fit="contain" lazy></el-image>
            {{item.BlackListMember.RealName}}
          </div>
          <div class="bolckButton" @click="remove(item)">{{$t('base.remove')}}</div>
        </li>
      </ul>
      <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-if="resultTpye" />
    </div>
  </div>
</template>
<script>
import { getInfo } from "@/api/public";
import FZF from "@/components/404.vue";
import NOTN from "@/components/notnull.vue";

export default {
  name: 'tabslist',
  components: { FZF, NOTN },
  data() {
    return {
      loading: false,
      list: '',
      resultTpye: false,
    }
  },
  props: {
    userInfo: {}
  },
  created() {
    this.getBlacklist()
  },
  mounted() {},
  methods: {
    getBlacklist() {
      let that = this
      let data = { Memberid: that.userInfo.MappingUserId, Token: that.userInfo.ChineseToken, Operator_id: that.userInfo.MappingUserId, nickName: '', pageIndex: 1 }
      that.$get(that.$interface.MyBlacklist, data).then(res => {
        if (res.result) {
          that.list = res.data
        } else {
          that.resultTpye=true
        }
      })
    },
    remove(obj) {
      let that = this
      let data = { Memberid: that.userInfo.MappingUserId, Token: that.userInfo.ChineseToken, Operator_id: that.userInfo.MappingUserId, TargetId: obj.BlackMemberId, Type: 2, }
      that.$post(that.$interface.OperateBlacklist, data).then(res => {
        if (res.result) {
          let msg = "Unblocked successfully"
          that.$message({
            type: 'warning',
            duration: 1000,
            message: msg
          });
          that.getBlacklist()
        } else {
          that.$message({
            type: 'error',
            duration: 1000,
            message: res.msg
          });
        }
      })
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/usertabslist.css";

.thousand_layout {
  width: auto;
}

.bolckList li {
  display: flex;
  border: 1px solid #e0e0e0;
  padding: 8px 16px;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.bolckName {
  display: flex;
  align-items: center;

}

.like_img {
  width: 64px;
  height: 64px;
  border-radius: 4px;
  margin-right: 8px;
}

.bolckButton {
  padding: 9px 8px;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #5F6DAE;
  color: #5F6DAE;
}

</style>



// WEBPACK FOOTER //
// src/pages/user/blocked.vue